import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
 
// route-level code splitting
const Home = () => import("../views/static/Home.vue");
const Contactus = () => import("../views/static/Contactus.vue");
const Aboutus = () => import("../views/static/Aboutus.vue");
const Products = () => import("../views/static/Products.vue");
const OurTeam = () => import("../views/static/OurTeam.vue");
const AwardsEvents = () => import("../views/static/AwardsEvents.vue");
const Memories = () => import("../views/static/Memories.vue");
const Careers = () => import("../views/static/Careers.vue");
const PageNotFound = () => import("../views/common/404-error.vue");
import ElementUI from 'element-ui';
import en from "element-ui/lib/locale/lang/en";
import ar from "element-ui/lib/locale/lang/ar";

export function createRouter() {
  const router = new Router({
    mode: "history",
    fallback: false,
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      //{ path: "/", redirect: "/flight" },
      { path: "/", component: Home, name: "home" },
      { path: "/contactus", component: Contactus, name: "Contactus" },
      { path: "/aboutus", component: Aboutus, name: "Aboutus" },
      { path: "/awards-events", component: AwardsEvents, name: "AwardsEvents" },
      { path: "/our-team", component: OurTeam, name: "OurTeam" },
      { path: "/products", component: Products, name: "Products" },
      { path: "/memories", component: Memories, name: "Memories" },
      { path: "/careers", component: Careers, name: "Careers" },
      { path: "/404-error", component: PageNotFound },
      { path: "*", redirect:'/404-error' },    ]
  });

  router.beforeResolve((to, from, next) => {
    let getLang = router.app.$store.getters['getLang'];
    // Load Conditional CSS 
    if (getLang && getLang === 'en') {
      Vue.use(ElementUI, { locale: en });
    } else { // Set the arabic or put the if else deliberate statement to handle other languages
      Vue.use(ElementUI, { locale: ar });
    }
   
    // Set locale
    if (router.app.$store) {
      const isAuthRequired = to.meta.auth;
      let _token = router.app.$store.getters['auth/getToken'];
     
     if (to.path === '/my-profile' && _token){
      setTimeout(function(){
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next({path:to.path})
      },100)
    }else if(to.path === '/my-profile' && !_token){
      setTimeout(function(){
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next({path:'/'})
      },100)
    }
    if (to.path === '/my-bookings' && _token){
      setTimeout(function(){
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next({path:to.path})
      },100)
    }else if(to.path === '/my-bookings' && !_token){
      setTimeout(function(){
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next({path:'/'})
      },100)
    }

    if (to.path === '/change-password' && _token){
      setTimeout(function(){
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next({path:to.path})
      },100)
    }else if(to.path === '/change-password' && !_token){
      setTimeout(function(){
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next({path:'/'})
      },100)
    }
      router.app.$store
        .dispatch("GET_I18N_LOCALE")
        .then(function() {
          let getLang = router.app.$store.getters['auth/getLang'];
          let getLocale = router.app.$store.getters.getLocale;
          router.app.$i18n.setLocaleMessage(getLang, getLocale);
          router.app.$i18n.locale = getLang;
          return next();
        })
        .catch(() => console.log("GET_I18N_LOCALE-error"));
    } else {
      next();
    }

    // Set container class name
    router.app.$store.dispatch("SET_CONTAINER_CLASS", to.name);
    // Set layout based on route
    router.app.$store.dispatch("SET_LAYOUT", to.name);
    next();
  });

  router.beforeEach (async (to, from, next) => {
    return next()
  });
  return router;
}



// WEBPACK FOOTER //
// src/router/index.js